define.alias("ember-power-select/components/power-select/before-options", "preview-grid/components/power-select/before-options");